import getTime from 'date-fns/get_time';
import isWithinRange from 'date-fns/is_within_range';
import isDate from 'date-fns/is_date';
import get from 'lodash/get';
import addDays from 'date-fns/add_days';
export var dateFilter = function dateFilter(item) {
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var timeStamp = arguments[3];
  var rawTimeStamp = get(item, timeStamp);
  if (!rawTimeStamp) {
    console.warn('order history item does not have a ' + timeStamp + ' property:', item);
    return false;
  }
  if (isDate(startDate) && isDate(endDate)) {
    return isWithinRange(rawTimeStamp, getTime(startDate), getTime(addDays(endDate, 1)));
  }
  return isWithinRange(rawTimeStamp, 0, Date.now());
};